import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import "../../Sass/Common.scss";
import PatientsCreateAndEdit from "../../Components/Patients/PatientsCreateAndEdit";
import { ReactComponent as PatientDetails } from "../../Assets/Icons/PharmsmartIcon/PatientDetails.svg";
// const PatientsCreateAndEdit = React.lazy(() =>
//   import("Components/Patients/PatientsCreateAndEdit")
// );

const useStyle = makeStyles((theme) => ({
  rsUpdateDialog: {
    "&>div": {
      "&>div": {
        background: "#efefef",
        maxHeight: "calc(100% - 20px)",
        padding: "10px 0px",
        borderRadius: "10px !important",
        "&>div:nth-child(1)": {
          "&>h2": {
            "&>p": {
              paddingBottom: "10px",
            },
          },
          "&>div:nth-child(1)": {
            // paddingTop: "10px",
            "&>svg": {
              height: "50px",
              width: "50px",
            },
          },
        },
      },
    },
    "& .MuiPaper-root.MuiPaper-elevation": {
      maxWidth: "1215px",
      top: "-15px !important",
      "&>div": {
        paddingTop: "0px",
        paddingBottom: "0px",
      },
    },
  },
}));
// Repeat Orders Patient Create
const PateintCreateDialog = (props) => {
  const { callBackOnSubmit, callBackOnCancel, open, setOpen } = props;
  const classes = useStyle();

  /** handle close */
  const handleClose = () => {
    setOpen(false);
  };

  /** call back patient on from submit */
  const callBackOfPatientFormSubmit = (responseData) => {
    handleClose();
    if (typeof callBackOnSubmit === "function") {
      callBackOnSubmit(responseData);
    }
  };
  /** call back patient on from cancle */
  const callBackOfPatientFormCancel = () => {
    handleClose();
    if (typeof callBackOnCancel === "function") {
      callBackOnCancel();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"lg"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={classes.rsUpdateDialog}
      >
        <PrimaryDialogTitle
          handleClose={handleClose}
          title="Create New Patient"
          icon={PatientDetails}
        />
        <DialogContent>
          <PatientsCreateAndEdit
            _pageAccessMode="create"
            callBackOnSubmit={callBackOfPatientFormSubmit}
            callBackOnCancel={callBackOfPatientFormCancel}
            dialog={true}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PateintCreateDialog;
